import { Vue,Component,Emit,Prop,Watch} from 'vue-property-decorator';
import Modal from '@/assets/common/Modal/Modal.vue'
import Thumbnail from '@/components/Thumbnail/Thumbnail.vue';
import { toCamel } from 'snake-camel';
import moment from "moment";
import store from '@/assets/common/store/store';
import List from '@/assets/common/List/List.vue';
import { AgriFieldList, Plantings, AgriFieldParam, File, ProducerAgriFieldGroup } from '@/types';
import { isAdmin, formatGroupedUsageReasons } from '@/assets/common/services'
import { LoginUser} from "@/types/Component";
import SelectPlanting from '@/components/SelectPlanting/SelectPlanting.vue';

type Producers = {
    pdId: string;
    pdName: string;
    pdNo: string;
    dateOfBirth: string;
}

type ProducersDetails = {
    producerId: string;
    producerNum: number | null;
    producerName: string;
}[]

type ProducersTenantDetails = {
    tenantId: string;
    tenantName: string;
    authority: string;
}

type ProducersGet = {
    producers: Producers[];
}
export type Item = {
    id: string;
    name: string;
    isActive: boolean;
    producerId: string
}

export type ProducerItem = {
    producerId: string;
    producerName: string;
    isOpen: boolean;
    agri_fields: Item[];
};

@Component({
    components: {
        List,
        SelectPlanting,
        Modal,
        Thumbnail
    }
})
export default class AgriFieldModal extends Vue {
    private title = this.isPesticidePlan ? '生産者/圃場' : '圃場';
    private tableTitle = '圃場情報'
    private isVisible = true
    private agriFields: AgriFieldList[] = []
    private producerAgriFields: ProducerAgriFieldGroup[] = []
    private agriFieldId = ''
    private agriFieldIdIsHidden = false
    private agriFieldName = ''
    private agriFieldArea = 0
    private agriFieldMemo = ''
    private agriFieldAddress = ''
    private agriFieldNum = ''
    private producerNum = ''
    private contractType = null
    private agriFieldDisplayStart = ''
    private agriFieldDisplayEnd = ''
    private agriFieldPlantings: Plantings[] = []
    // 楽観チェック用：画面表示時点の紐付け作付のスナップショット（未選択になった作付＝削除、DBにない作付＝追加として扱う）
    private originalPlantings: Array<{ id: string, updated: string | null }> = []
    private agriFieldFileIds: string[] = []
    private selectedPlantings: Plantings[] = []
    private selectedAgrifield!: AgriFieldParam
    private selectedPlantingIds: string[] = []
    private selectedProducerId: string | null = null;
    private originalProducerId: string | null = null;
    private tempSelectedProducerId: string | null = null;
    private tempSelectedProducerTenantId: string | null = null;
    private selectedTenantId: string | null = null;
    private selectedProducerTenantId: string | null = null;
    private images: File[] = []
    private files: File[] = []
    private isLoading = false
    private isSpinnerLoading = false
    private isShowSelectPlanting = false
    private preSelectPlantingId: string[] = []
    private apiBaseUrl = '/agri_fields'
    private apiBaseAdminUrl = '/admin/agri_fields'
    private clientBaseUrl = '/master/agri-fields'
    private producersUrl = '/producers'
    private deletedFiles: File[] = []
    private withHidden = false;
    private isEditable = true
    private producersList: Producers[] = []
    private producersDetails: ProducersDetails[] = []
    private producersTenantList: ProducersTenantDetails[] = []
    private isSwitchDisplay = false
    private expandableTree = false
    private dataHeight = { height: '0px' }
    private isOpen = false;
    private items: Item[] | ProducerItem[] = [];
    private searchText = ''
    private producerId = ''
    private checked = false;
    private originalItems: Item[] | ProducerItem[] = [];
    private alteredAgriField = false;
    private selectedItem = "";
    private hiddenSwitchbtn = false;

    @Prop() 
    isShowAgriFieldModal!: boolean

    get isPesticidePlan() {
        return this.$store.getters.loginUser.isPesticidePlan;
    }

    get pesticidePlanProducer() {
        return this.$store.getters.loginUser.pesticidePlanProducer;
    }

    @Watch('isShowAgriFieldModal')
    onIsShowAgriFieldModalChanged(newVal: boolean) {
        if (newVal) {
            if (this.isPesticidePlan) {
                this.expandableTree = false
                this.getAgriFieldsByProducers();
            } else {
                this.getAgriFields()
            }
            this.isEditable = isAdmin(this.$store.getters.loginUser)
            if (this.isPesticidePlan) {
                this.getProducers()
                this.getProducersTenant()
            }
        }
    }

    @Watch('isShowAgriFieldModal')
    onModalVisibilityChanged(val: boolean) {
        this.$emit('update-inert', val)
    }

    private handleProducerToggle(toggledProducer: any) {
        this.producerAgriFields = this.producerAgriFields.map(producer => {
            if (producer.producerId === toggledProducer.producerId) {
                return { ...toggledProducer };
            }
            return producer;
        });
    }

    private async getAgriFields() {
        this.isLoading = true
        this.isSpinnerLoading = true
        await this.$apiClient.doRequest('get', `${this.apiBaseUrl}?with_hidden=${this.withHidden}`).then((ret) => {
            this.agriFields = ret.agri_fields.map((item: any) => ({...item, isActive: item.id === this.selectedItem }))
            this.items = this.agriFields as unknown as Item[];
            this.originalItems = [...this.items];
            if(this.selectedItem){
                this.sendItem(this.selectedItem, false, this.tempSelectedProducerId ?? "");
            }
            this.doSearch();
        })
        .finally(() => {
            this.isLoading = false
            this.isSpinnerLoading = false
        })
    }

    private async getAgriFieldsByProducers() {
        this.isLoading = true;
        this.isSpinnerLoading = true;
        await this.$apiClient.doRequest('get', `${this.apiBaseAdminUrl}/groupedByProducer?with_hidden=${this.withHidden}`)
            .then((ret) => {
                    const producers = ret.map((producer: any) => {
                    const agriFields = Array.isArray(producer.agri_fields)
                    ? producer.agri_fields
                        .sort((a: any, b: any) =>
                            a.name.localeCompare(b.name, 'ja-JP')
                        )
                        .map((field: any) => ({
                            ...field,
                            isActive:
                            field.id === this.selectedItem &&
                            producer.producerId === this.tempSelectedProducerId
                        }))
                    : [];
                    return {
                    ...producer,
                    agri_fields: agriFields
                    };
                });
                this.producerId = this.tempSelectedProducerId ?? "";
                const updatedProducers = this.preserveIsOpenState(producers, this.producerAgriFields);
                this.producerAgriFields = updatedProducers;
                this.items = this.producerAgriFields as unknown as ProducerItem[];
                this.originalItems = [...this.items];
                if(this.selectedItem){
                    this.sendItem(this.selectedItem, false, this.tempSelectedProducerId ?? "");
                }
            this.doSearch();
            })
            .finally(() => {
                this.isLoading = false;
                this.isSpinnerLoading = false;
            });
    }

    private getProducers() {
        this.$apiClient
            .doRequest('get', `${this.producersUrl}`)
            .then(res => {
                this.producersList = (toCamel(res) as ProducersGet).producers as Producers[];
            })
            .catch(error => {
                console.error('Failed to fetch producers:', error);
            });
    }

    private async getProducersTenant() {
        this.$apiClient
            .doRequest('get', `${this.producersUrl}/producers_tenant/${this.tempSelectedProducerId}`)
            .then(res => {
                this.producersTenantList = toCamel(res.producersTenant) as ProducersTenantDetails[];
                if (this.producersTenantList.length === 1) {
                    this.tempSelectedProducerTenantId = this.producersTenantList[0].tenantId
                }
            })
            .catch(error => {
                console.error('Failed to fetch producers:', error);
            });
    }

    private preserveIsOpenState(newProducers: any[], oldProducers: any[]) {
        return newProducers.map((newProducer) => {
            const oldProducer = oldProducers.find(
                (p) => p.producerId === newProducer.producerId
            );
        
            return {
                ...newProducer,
                isOpen: oldProducers.length === 0 ? true : oldProducer?.isOpen ?? false,
            };
        });
    }

    openSideBar = () => {
        const isResponsive = window.matchMedia('(max-width: 1000px)').matches;
        if (!isResponsive) {
            return; 
        }
        if(document.body.classList.contains('newsSide')){
            document.body.classList.remove('newsSide')
        }else{
            document.body.classList.add('newsSide')
        }
    }

    closeModal() {
        if (this.alteredAgriField && !window.confirm("変更内容を破棄します。よろしいですか？")) {
            return;
        }
        this.$emit('update:isShowAgriFieldModal', false);
        this.items = [];
        this.originalItems = [];
        this.agriFields = [];
        this.producerAgriFields = [];
        this.searchText = '';
        this.checked = false;
        this.withHidden = false;
        this.agriFieldId = '';
        this.selectedItem = '';
        this.deletedFiles = []
        this.alteredAgriField = false;
        this.hiddenSwitchbtn = false;
    }

    inputChangedCheck(){
        if(this.alteredAgriField==true && this.hiddenSwitchbtn === false){
            const confirm = window.confirm('変更内容を破棄します。よろしいですか？')
            if(confirm){
                this.alteredAgriField = false
            }
        }
    }

    private async onProducerChange() {
        if (this.hasAgriFieldInput()) {
            const confirmed = confirm('入力した内容をクリアしますよろしいですか？');
            if (!confirmed) {
                this.tempSelectedProducerId = this.selectedProducerId
                return;
            }
            this.clearAgriFieldDatas();
        }
        this.tempSelectedProducerTenantId = null
        const newProducerId = this.tempSelectedProducerId;
        this.producerNum = String(this.producersList.find(item => item.pdId === newProducerId)?.pdNo ?? "");
        await this.getProducersTenant();
        if (!this.isPesticidePlan) {
            await this.getProducerDetails()
        }
    }

    private setAgrifieldTenant() {
        if (this.hasAgriFieldInput()) {
            const confirmed = confirm('入力した内容をクリアしますよろしいですか？');
            if (!confirmed) {
                this.tempSelectedProducerTenantId = this.selectedProducerTenantId
                return;
            }
            this.clearAgriFieldDatas();
        }
    }

    private onProducerSelect() {
        this.selectedProducerId = this.tempSelectedProducerId;
    }

    private onTenantSelect() {
        this.selectedProducerTenantId = this.tempSelectedProducerTenantId;
    }

    deleteAgriField() {
        const confirm = window.confirm('削除しますか？')
        this.isLoading = true
        if (this.files && this.files.length > 0) {
            this.deletedFiles.push(...this.files);
        }
        
        if (this.images && this.images.length > 0) {
            this.deletedFiles.push(...this.images);
        }
        
        if (confirm) {
            const updatedParam = this.selectedAgrifield?.updated ? `?updated=${encodeURIComponent(this.selectedAgrifield.updated)}` : ''
            this.$apiClient.doRequest('delete', `${this.apiBaseAdminUrl}/${this.agriFieldId}${updatedParam}`)
                .then((response: any) => {
                    if (response) {
                        alert(response);
                        this.deletedFiles = []
                        this.isLoading = false;
                        return;
                    }
                    const promise: any = []
                    this.deletedFiles.forEach(file => {
                       promise.push(this.$apiClient.doRequest('delete', `${this.apiBaseAdminUrl}/${this.agriFieldId}/files/${file.id}?tenant_id=${this.tempSelectedProducerTenantId}`))
                    })
                    this.alteredAgriField = false;
                    this.$toasted.success('削除しました。')
                    if (this.isPesticidePlan) {
                        this.expandableTree = true
                        this.getAgriFieldsByProducers();
                    } else {
                        this.getAgriFields()
                    }
                    this.addAgriField(false);
                    this.deletedFiles = []
                })
                .catch(() => {
                    this.deletedFiles = []
                    this.$toasted.error('削除に失敗しました。')
                })
        } else {
            this.deletedFiles = []
            this.$toasted.success('削除がキャンセルされました。')
            this.isLoading = false
        }
    }

    private toggleProducer(selectedProducer: ProducerItem) {
        selectedProducer.isOpen = !selectedProducer.isOpen;
        return selectedProducer;
    }

    private async sendItem(itemId: string, flag:boolean, producerId?: string): Promise<void> {
        if (itemId === this.selectedItem && flag === true) {
            return;
        }
        this.inputChangedCheck()
        if(this.alteredAgriField == false){
            if (!this.isProducerItemList(this.items)) {
                (this.items as Item[]).forEach(item => {
                  this.$set(item, 'isActive', item.id === itemId)
                })
            } else {
            (this.items as ProducerItem[]).forEach(producer => {
                producer.agri_fields.forEach(field => {
                this.$set(
                    field,
                    'isActive',
                    field.id === itemId && producer.producerId === producerId
                )
                })
            })
            }
        await this.setAgriField(itemId, flag, producerId ?? "");
        }else{
            this.hiddenSwitchbtn = false;
        }
    }

    private cancelEdit() {
        if(this.alteredAgriField){
            if (this.alteredAgriField) {
                const result = window.confirm('変更内容を破棄します。よろしいですか？');
                if (!result) {
                    return false;
                }
            }
            this.alteredAgriField = false;
            this.hiddenSwitchbtn = false;
            if (this.agriFieldId !== 'create') {
                this.producerId = this.originalProducerId || "";
                this.setAgriField(this.agriFieldId, false, this.producerId)
            } else {
                this.addAgriField(false)
            }
        }
    }

    public get isAgriFieldDisabled(): boolean {
        return this.isPesticidePlan ? !this.tempSelectedProducerId || !this.tempSelectedProducerTenantId : false;
    }

    @Emit('inputChanged')
    inputChanged() {
        if(this.alteredAgriField == false){
            this.alteredAgriField = true
        }
    }

    private checkDecimalPoint() {
        const splitedDecimalPoint = this.agriFieldArea.toString().split('.')
        if (splitedDecimalPoint[1] && splitedDecimalPoint[1].length > 10) {
            this.agriFieldArea = parseInt(splitedDecimalPoint[0])
        }
        this.inputChanged()
    }

    private async setAgriField(itemId: string, flag: boolean, producerId: string) {
        this.selectedItem = itemId;
        this.producerAgriFields.forEach((producer: any) => {
                producer.agri_fields.forEach((field: any) => {
                field.isActive = field.id === itemId &&
                producer.producerId === producerId;
            });
        });
        const agriField = this.producerAgriFields.flatMap(group => group.agri_fields).find(field => field.id === itemId);
        this.tempSelectedProducerTenantId = agriField?.tenantId ?? null;
        if (this.alteredAgriField == false) {
            this.getProducers();
            this.tempSelectedProducerId = producerId ? producerId : this.tempSelectedProducerId;
            this.producerId = this.tempSelectedProducerId ?? "";
            this.tableTitle = '圃場情報'
            this.images = []
            this.files = []
            this.deletedFiles = []
            this.preSelectPlantingId = []
            this.$apiClient.doRequest('get', `${this.apiBaseUrl}/${itemId}?producerId=${this.tempSelectedProducerId}&tenant_id=${this.tempSelectedProducerTenantId}`).then((ret) => {
                this.selectedProducerId = this.isPesticidePlan ? ret.producers?.[0]?.producerId : null;
                this.tempSelectedProducerId = this.isPesticidePlan ? ret.producers?.[0]?.producerId : null;
                this.agriFieldId = ret.id
                this.agriFieldName = ret.name
                this.agriFieldArea = this.$apiClient.exponentToDecimal(ret.planted_area) as any
                this.selectedAgrifield = toCamel(ret) as AgriFieldParam
                this.agriFieldMemo = ret.memo
                this.agriFieldDisplayStart = ret.display_start
                this.agriFieldDisplayEnd = ret.display_end
                this.agriFieldPlantings = ret.plantings ?? []
                this.originalPlantings = (ret.plantings ?? []).map((p: any) => ({ id: p.id, updated: p.updated ?? null }))
                this.producersDetails = (ret.producers ?? []) as ProducersDetails[]
                this.agriFieldFileIds = ret.file_id
                this.agriFieldIdIsHidden = ret.is_hidden
                this.agriFieldAddress = ret.agriFieldAddress
                this.agriFieldNum = ret.agriFieldNum
                this.contractType = ret.contractType ?? null;
                this.selectedProducerTenantId = this.isPesticidePlan ? ret?.tenantId : null;
                this.tempSelectedProducerTenantId = this.isPesticidePlan ? ret?.tenantId : null;
                this.producersTenantList = (this.isPesticidePlan && ret?.tenantId)
                    ? [{ tenantId: ret.tenantId, tenantName: ret.tenantName ?? ret.tenantId, authority: 'OWNER' }]
                    : [];
                this.originalProducerId = this.isPesticidePlan ? ret.producers?.[0]?.producerId : null;
                const matchedProducer = this.producersList.find(p => p.pdId === producerId);
                const rawProducerNum = matchedProducer?.pdNo ?? ret.producerNum;
                this.producerNum = rawProducerNum == null ? '' : String(rawProducerNum).padStart(4, '0');
                this.getFiles(ret.file_id)
                if(flag){
                    this.openSideBar();
                }

                if (ret.plantings) {
                    ret.plantings.forEach((item: any) => {
                        this.preSelectPlantingId.push(item.id)
                    })
                }
            })
        }
    }

    @Watch('searchText')
    private doSearch(): void {
        const search = this.searchText.trim();
        if (!search) {
            if (this.isProducerItemList(this.originalItems)) {
                this.items = [...(this.originalItems as ProducerItem[])];
            } else {
                this.items = [...(this.originalItems as Item[])];
            }
            return;
        }

        if (this.isProducerItemList(this.originalItems)) {
            const filteredProducers = (this.originalItems as ProducerItem[])
                .map(producer => {
                    const isProducerMatch = producer.producerName?.includes(search);
                    const filteredFields = producer.agri_fields.filter(field =>
                        field.name?.includes(search)
                    );

                    if (isProducerMatch || filteredFields.length > 0) {
                        return {
                            ...producer,
                            agri_fields: isProducerMatch ? producer.agri_fields : filteredFields,
                            isOpen: producer.isOpen
                        };
                    }
                    return null;
                })
                .filter((p): p is ProducerItem => p !== null);

            this.items = filteredProducers;
        } else {
            this.items = (this.originalItems as Item[]).filter(item =>
                item.name?.includes(search)
            );
        }
    }

    private getFiles(fileIds: string[]) {
        const promises: any = []
        fileIds.forEach(id => {
            promises.push(this.getFile(this.agriFieldId, id))
        })
        Promise.all(promises).then(ret => {
            ret.forEach((file: any) => {
                if (this.$apiClient.isImageFile(file.meta.name)) {
                    this.images.push(file)
                } else {
                    this.files.push(file)
                }
            })
        })
    }

    private dateFormat(date: Date) {
        const year = new Date(date).getFullYear()
        const month = new Date(date).getMonth() + 1
        return year + '年' + month + '月'
    }

    private getFile(agriFieldId: string, fileId: string) {
        return this.$apiClient.doRequest('get', `${this.apiBaseUrl}/${agriFieldId}/files/${fileId}?tenant_id=${this.tempSelectedProducerTenantId}`)
    }

    private addAgriField(flag:boolean) {
        if (this.isPesticidePlan) {
            this.getProducers()
        }
        else {
            this.getProducerDetails();
        }
        this.inputChangedCheck()
        if (this.alteredAgriField == false) {
            this.selectedItem = ''
            this.tableTitle = '新規圃場'
            this.agriFieldId = 'create'
            this.agriFieldName = ''
            this.agriFieldArea = 0
            this.agriFieldMemo = ''
            this.agriFieldAddress = ''
            this.agriFieldNum = ''
            this.contractType = null
            this.agriFieldDisplayStart = ''
            this.agriFieldDisplayEnd = ''
            this.agriFieldPlantings = []
            this.originalPlantings = []
            this.agriFieldIdIsHidden = false
            this.images = []
            this.files = []
            this.deletedFiles = []
            this.preSelectPlantingId = []
            this.selectedProducerTenantId = null
            this.tempSelectedProducerTenantId = null
            this.selectedProducerId = null
            this.tempSelectedProducerId = null;
            this.producersTenantList = []
            if(flag){
                this.openSideBar();
            }
            if (this.isProducerItemList(this.items)) {
            (this.items as ProducerItem[]).forEach(producer => {
                producer.agri_fields.forEach(field => {
                    field.isActive = false;
                });
            });
            } else if (Array.isArray(this.items)) {
                (this.items as Item[]).forEach(field => {
                    field.isActive = false;
                });
            }
        }
    }

    private async getProducerDetails() {
        this.selectedProducerId = this.isPesticidePlan ? this.tempSelectedProducerId : this.$store.getters.loginUser.id;
        this.$apiClient
            .doRequest('get', `${this.producersUrl}/${this.selectedProducerId}`)
            .then(res => {
                this.producerId = res.pdId;
                this.producerNum = res.pdNo
            })
            .catch(error => {
                console.error('Failed to fetch producer:', error);
            });
    }

    @Watch('checked')
    private toggleHiddenItems(value: boolean) {
        this.expandableTree = true
        this.withHidden = value;
        this.hiddenSwitchbtn = true;
        if (this.isPesticidePlan) {
            this.getAgriFieldsByProducers();
        } else {
            this.getAgriFields()
        }
    }

    private isProducerItemList(items: (Item | ProducerItem)[]): items is ProducerItem[] {
        return items.length > 0 && 'agri_fields' in items[0];
    }

    private calcDataHeight() {
        let diff = 0
        const headerHeight = (this.$refs.header as HTMLElement)?.offsetHeight ?? 0
        const footerHeight = (this.$refs.footer as HTMLElement)?.offsetHeight ?? 0
        diff = diff + headerHeight + footerHeight
        this.dataHeight = { height: `calc(100% - ${diff}px` }
    }

    private addPlant() {
        this.selectedTenantId = this.tempSelectedProducerTenantId;
        this.isShowSelectPlanting = true
        this.$emit("agri-planting-inert",true)
    }

    @Watch('isShowSelectPlanting')
    onPlantingModalVisibility(val: boolean) {
        this.$emit('agri-planting-inert', val)
    }

    private hasAgriFieldInput(): boolean {
        return !!(
            this.agriFieldName ||
            this.agriFieldArea ||
            this.agriFieldMemo ||
            this.agriFieldAddress ||
            this.contractType ||
            this.agriFieldDisplayStart ||
            this.agriFieldDisplayEnd ||
            (this.images && this.images.length > 0) ||
            (this.files && this.files.length > 0) ||
            (this.preSelectPlantingId && this.preSelectPlantingId.length > 0) ||
            (this.agriFieldPlantings && this.agriFieldPlantings.length > 0)
        );
    }

    private clearAgriFieldDatas() {
        this.agriFieldPlantings = [];
        this.originalPlantings = [];
        this.preSelectPlantingId = []
        this.agriFieldIdIsHidden = false
        this.producersDetails = [];
        this.deletedFiles = []
    }

    private closeSelectPlantingModal() {
        this.isShowSelectPlanting = false
    }

    private async setPlanting(plantings: any) {
        const newPlantingIds = new Set((plantings as any[]).map((item) => item.id))
        const removedPlantings = this.agriFieldId !== 'create'
            ? this.agriFieldPlantings.filter((item) => !newPlantingIds.has(item.id))
            : []

        const blockedGroups: Array<{ name: string, reasons: string[] }> = []
        for (const removed of removedPlantings) {
            const url = `/plantings/check_agri_field_deletable/${removed.id}/${this.agriFieldId}`
            const reasons: string[] = await this.$apiClient.doRequest("get", url)
            if (reasons && reasons.length > 0) {
                blockedGroups.push({ name: removed.name, reasons })
            }
        }
        if (blockedGroups.length > 0) {
            window.alert(formatGroupedUsageReasons(blockedGroups))
            return
        }

        this.agriFieldPlantings = plantings as Plantings[]
        this.preSelectPlantingId = []
        plantings.forEach((item: any) => {
            this.preSelectPlantingId.push(item.id)
        })
        this.inputChanged()
    }

    private onFileChange(e: any) {
        const files = e.target.files || e.dataTransfer.files;

        if (this.$apiClient.isSizeOver(files)) {
            return
        }

        if (this.$apiClient.isImageFile(files[0].name)) {
            this.$apiClient.getBase64(files[0]).then((image: any) => {
                const item = {
                    file: image.file,
                    url: image.base64
                } as File
                this.images.push(item)
            }).catch(() => {
                window.alert('画像ファイルが読み込めませんでした')
            })
        } else {
            const item = {
                file: files[0],
                url: '',
                meta: {
                    name: files[0].name
                }
            } as File
            this.files.push(item)
        }
        e.target.value = ''
        this.inputChanged()
    }

    private switchDisplayAgriField() {
        if (!window.confirm(`${this.selectedAgrifield.name}を${this.agriFieldIdIsHidden ? '表示状態に戻します' : '非表示にします'}。よろしいですか？`)) {
            return
        }
        this.hiddenSwitchbtn = true;
        this.isSwitchDisplay = true;
        this.agriFieldIdIsHidden = !this.agriFieldIdIsHidden
        const updatedParam = this.selectedAgrifield?.updated ? `&updated=${encodeURIComponent(this.selectedAgrifield.updated)}` : ''
          this.$apiClient.doRequest("put", `${this.apiBaseAdminUrl}/${this.agriFieldId}/display?is_hidden=${this.agriFieldIdIsHidden}&tenant_id=${this.tempSelectedProducerTenantId}${updatedParam}`)
            .then(response => {
                if (response && response.message) {
                    window.alert(response.message)
                    this.agriFieldIdIsHidden = !this.agriFieldIdIsHidden
                    this.hiddenSwitchbtn = false
                    return
                }
                this.$toasted.success(this.agriFieldIdIsHidden ? `非表示に変更しました。` : `表示に変更しました。`)
                this.$emit('update:isRefresh', true);
                // 変更後の updated を反映しないと、直後の削除/保存が誤って
                // 楽観ロック競合と判定されてしまうため、フォーム全体を再取得せず updated だけ反映する
                if (response && response.updated) {
                    this.selectedAgrifield.updated = response.updated
                }
                if (this.isPesticidePlan) {
                       this.expandableTree = true
                        this.getAgriFieldsByProducers();
                    } else {
                        this.getAgriFields()
                }
            })
            .catch(error => {
                this.$toasted.error('変更に失敗しました。')
            })
            .finally(() => {
                this.isLoading = false
            })
    }

    private async submit(isHiddenUpdate: boolean) {
    const errmsg: string[] = []
        if (this.isPesticidePlan) {
            if (!this.tempSelectedProducerId) {
                errmsg.push("生産者を選択してください")
            }
            if (this.tempSelectedProducerId && !this.tempSelectedProducerTenantId) {
                errmsg.push("生産者のテナントを選択してください")
            }
        }
        // 名前の入力
        if (!this.agriFieldName.trim()) {
            errmsg.push("圃場名前を入力してください")
        }
        // 名前の長さ
        if (this.agriFieldName.length > 100) {
            errmsg.push(`圃場名前は100文字以内で入力してください（現在は${this.agriFieldName.length}文字）`)
        }
        // 面積
        if (!this.agriFieldArea?.toString() || this.agriFieldArea < 0) {
            errmsg.push("面積は0以上の値を入力してください")
        } else {
            // 面積の数値チェック
            const isMinus: boolean = /-/.test(this.agriFieldArea.toString())
            const integer: string = this.agriFieldArea.toString().split('.')[0]
            const decimal: string = this.agriFieldArea.toString().split('.')[1]
            if (isMinus || integer.length > 10 || decimal && decimal.length > 10) {
                errmsg.push("面積は0以上の整数部10桁小数部10桁までの数値を入力してください")
            }
        }
        // 住所の長さ
        const address = (this.agriFieldAddress || '').trim();
        if (address.length > 200) {
            errmsg.push(`住所は200文字以内で入力してください（現在は${this.agriFieldAddress.length}文字）`);
        }
        // 表示日付
        if (moment(this.agriFieldDisplayStart).isAfter(moment(this.agriFieldDisplayEnd))) {
            errmsg.push("表示開始日は表示終了日以前で設定してください")
        }
        // メモ
        if (this.agriFieldMemo && this.agriFieldMemo.length > 21844) {
            errmsg.push(`メモは21844文字以内で入力してください（現在は${this.agriFieldMemo.length}文字）`)
        }
        // 生産者番号のチェック
        if (this.isPesticidePlan && this.tempSelectedProducerId && !this.producerNum && !this.isSwitchDisplay) {
            errmsg.push(`生産者番号が登録されていません。`)
        }
        if (errmsg.length > 0) {
            window.alert(errmsg.join('\n'))
            return false
        }

        if (this.agriFieldPlantings) {
            this.agriFieldPlantings.forEach(item => {
                this.selectedPlantingIds.push(item.id)
            })
        }

        const selectedFiles = this.images.concat(this.files)

        const params: AgriFieldParam = {
            'producer_id': this.tempSelectedProducerId ?? null,
            'producer_tenant_id': this.tempSelectedProducerTenantId ?? null,
            'name': this.agriFieldName?.trim(),
            'planted_area': this.agriFieldArea ? this.agriFieldArea : 0,
            'agri_field_address': this.agriFieldAddress?.trim(),
            'contract_type': this.contractType,
            'memo': this.agriFieldMemo?.trim(),
            'display_start': this.agriFieldDisplayStart,
            'display_end': this.agriFieldDisplayEnd,
            'plantings': this.selectedPlantingIds,
            'original_plantings': this.originalPlantings,
            'is_hidden': this.agriFieldIdIsHidden,
            'updated': this.selectedAgrifield?.updated ?? null
        }
        this.isLoading = true;
        try {
            if (this.agriFieldId === 'create') {
                const ret = await this.$apiClient.doRequest('post', this.apiBaseAdminUrl, params);
                if (ret && ret.message) {
                    window.alert(ret.message)
                    return false
                }
                const newAgriFieldId = ret.id;
                if (selectedFiles.length > 0) {
                    const promise: any = []
                    for (const item of selectedFiles) {
                        promise.push(this.$apiClient.fileUpload(`${this.apiBaseAdminUrl}/${ret.id}/files?tenant_id=${this.tempSelectedProducerTenantId}`, item.file))
                    }
                    try {
                        await Promise.all(promise)
                    } catch (error) {
                        this.$toasted.error('ファイルの保存に失敗しました。')
                        return false
                    }
                }
                if (this.isPesticidePlan) {
                    this.expandableTree = true
                    this.getAgriFieldsByProducers();
                } else {
                    this.getAgriFields()
                }
                this.deletedFiles = []
                this.images = []
                this.files = []
                this.alteredAgriField = false
                await this.sendItem(newAgriFieldId, false, this.tempSelectedProducerId ?? "");
                this.$toasted.success('変更を保存しました。');
            } else if (this.agriFieldId) {
                const result = window.confirm("内容を上書きして保存します。よろしいですか？")
                if (!result) {
                    this.isLoading = false
                    return false;
                }
                const ret = await this.$apiClient.doRequest('put', `${this.apiBaseAdminUrl}/${this.agriFieldId}`, params)
                if (ret && ret.message) {
                    window.alert(ret.message)
                    return false
                }
                const promise: any = []
                if (selectedFiles.length > 0) {
                    const uploadFiles = selectedFiles.filter((file: File) => !file.id)
                    for (const item of uploadFiles) {
                        promise.push(this.$apiClient.fileUpload(`${this.apiBaseAdminUrl}/${ret.id}/files?tenant_id=${this.tempSelectedProducerTenantId}`, item.file))
                    }
                }
                this.deletedFiles.forEach(file => {
                    promise.push(this.$apiClient.doRequest('delete', `${this.apiBaseAdminUrl}/${this.agriFieldId}/files/${file.id}?tenant_id=${this.tempSelectedProducerTenantId}`))
                })
                try {
                    await Promise.all(promise)
                } catch (error) {
                    this.$toasted.error('ファイルの保存に失敗しました。')
                    return false
                }
                if (this.isPesticidePlan) {
                    this.expandableTree = true
                    this.getAgriFieldsByProducers();
                } else {
                    this.getAgriFields()
                }
                this.deletedFiles = []
                this.images = []
                this.files = []
                this.$toasted.success('変更を保存しました。')
                // 保存後の updated を反映しないと、直後の削除/表示切替が誤って
                // 楽観ロック競合と判定されてしまうため、最新状態を再取得する
                this.alteredAgriField = false
                await this.setAgriField(this.agriFieldId, false, this.tempSelectedProducerId ?? "")
            }
            this.alteredAgriField = false
        } catch (error) {
            this.$toasted.error('変更に失敗しました。');
        } finally {
            this.isLoading = false;
            this.selectedPlantingIds = [];
        }
    }

    private deleteFile(file: File, index: number) {
        this.files.splice(index, 1)
        if (file.id) {
            this.deletedFiles.push(file)
        }
    }

    private deleteImage(image: File, index: number) {
        this.images.splice(index, 1)
        if (image.id) {
            this.deletedFiles.push(image)
        }
    }
        
}
